import Vue from 'vue'
import VueRouter from 'vue-router'
import EstadoCuentas from '@/views/EstadoCuentas.vue'
const CuentaDetalle = () => import(/* webpackChunkName: 'cuenta' */ '@/views/CuentaDetalle')
const CuentaResumen = () => import(/* webpackChunkName: 'cuenta' */ '@/views/CuentaResumen')
const CuentaResumenAnual = () => import(/* webpackChunkName: 'cuenta' */ '@/views/CuentaResumenAnual')
const PrestamoDetalle = () => import(/* webpackChunkName: 'prestamo' */ '@/views/PrestamoDetalle')
const PrestamosCronograma = () => import(/* webpackChunkName: 'prestamo' */ '@/views/PrestamosCronograma')
const PlazoFijoDetalle = () => import(/* webpackChunkName: 'plazofijo' */ '@/views/PlazoFijoDetalle')
const FacturaCredito = () => import(/* webpackChunkName: 'facturacredito' */ '@/views/FacturaCredito')
const ExtractosHistorico = () => import(/* webpackChunkName: 'extractos' */ '@/views/ExtractosHistorico')
const Becas = () => import(/* webpackChunkName: 'becas' */ '@/views/Becas')
import NotFound from '@/views/NotFound'
import SessionService from '@/services/SessionService'
import {LOGIN_URL, SITE_NAME} from '@/config'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'estado_cuentas' }
  },
  {
    path: '/login',
    redirect: { name: 'estado_cuentas' }
  },
  {
    path: '/estado_cuentas',
    name: 'estado_cuentas',
    component: EstadoCuentas
  },
  {
    path: '/cuenta_corriente/:cuenta?/:periodo?',
    name: 'cuenta_corriente',
    component: CuentaDetalle
  },
  {
    path: '/cuenta_resumen/:cuenta?/:periodo?',
    name: 'cuenta_resumen',
    component: CuentaResumen
  },
  {
    path: '/resumen_anual/:cuenta?/:anio?',
    name: 'resumen_anual',
    component: CuentaResumenAnual
  },
  {
    path: '/plazo_fijo/:plazoFijo?',
    name: 'plazo_fijo',
    component: PlazoFijoDetalle
  },
  {
    path: '/prestamos/:prestamo?',
    name: 'prestamos',
    component: PrestamoDetalle
  },
  {
    path: '/prestamos/cronograma/:anio?',
    name: 'prestamos-cronograma',
    component: PrestamosCronograma
  },
  {
    path: '/factura_credito',
    name: 'factura_credito',
    component: FacturaCredito
  },
  {
    path: '/extractos_historico',
    name: 'extractos_historico',
    component: ExtractosHistorico
  },
  {
    path: '/becas',
    name: 'becas',
    component: Becas
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // Is logged in?
  if (!SessionService.isLoggedIn()) {
    location.href = `${LOGIN_URL}?nombre=${SITE_NAME}&redirect=${location.origin}${to.path}`
    return
  }

  next()
})

export default router
